// @flow
import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import {Switch} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
};

const HideCatalogueProfile = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const {id, exhibition, updateExhibition} = props

    const toggleHideCatalogueProfile = () => {
        updateExhibition(id, !exhibition.hideCatalogueProfile, Update.HideCatalogueProfile)
    }
    return (
        <ListItem>
            <ListItemText
                primary={t('Hide Profile Info')}
                secondary={t('If you enable this, then profile in exhibitor \'s catalogue will not be accessible.')}
            />
            <Switch
                edge="end"
                onChange={toggleHideCatalogueProfile}
                checked={exhibition.hideCatalogueProfile}
            />
        </ListItem>
    );
};

export default HideCatalogueProfile